exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editr pre {\n    background: #ededed;\n    font-family: monospace;\n    padding: 2px;\n    color: red;\n}\n\n", ""]);

// exports
